import { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info)
  }

  override render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div className="min-h-screen flex flex-col bg-gray-50">
          <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-3">
            <button
              onClick={() => { this.setState({ hasError: false }); window.history.back() }}
              className="text-gray-400 p-1 text-xl"
            >
              ←
            </button>
            <span className="font-semibold text-gray-800 text-sm">Ошибка</span>
          </header>
          <div className="flex-1 flex items-center justify-center px-4">
            <div className="text-center max-w-sm">
              <div className="text-5xl mb-4">⚠️</div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">Что-то пошло не так</h2>
              <p className="text-sm text-gray-500 mb-6">{this.state.error?.message}</p>
              <div className="flex flex-col gap-3">
                <button
                  onClick={() => { this.setState({ hasError: false }); window.history.back() }}
                  className="border border-gray-300 text-gray-700 px-6 py-2 rounded-xl font-medium"
                >
                  ← Назад
                </button>
                <button
                  onClick={() => window.location.reload()}
                  className="bg-brand-600 text-white px-6 py-2 rounded-xl font-medium"
                >
                  Перезагрузить
                </button>
              </div>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
